module.exports = __webpack_public_path__ + "static/media/full_logo.7912a30f.png";